import { Injectable, signal } from '@angular/core';
import { AppSettings, gfliTheme } from '../config';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  private optionsSignal = signal<AppSettings>(gfliTheme);

  getOptions() {
    const options = this.optionsSignal();
    options.theme = localStorage.getItem('theme') || 'light';
    return options;
  }

  setOptions(options: Partial<AppSettings>) {
    this.optionsSignal.update((current) => ({
      ...current,
      ...options
    }));
  }

  setLanguage(lang: string) {
    this.setOptions({ language: lang });
  }

  getLanguage() {
    return this.getOptions().language;
  }
}
